import React from 'react';
import { ArchiveIcon, BoxesIcon, CircleDollarSignIcon, ClipboardListIcon, PackageCheckIcon, TrendingUpIcon } from 'lucide-react';
type SummaryMetric = {
  label: string;
  value: string;
  detail: string;
};
const onePeopleSummaryMetrics: SummaryMetric[] = [{
  label: 'Received products',
  value: '189',
  detail: 'Products'
}, {
  label: 'Available for sale products',
  value: '83',
  detail: 'Products'
}, {
  label: 'Live products',
  value: '80',
  detail: 'Products'
}, {
  label: 'Received units',
  value: '1,902',
  detail: 'Units'
}, {
  label: 'Available for sale units',
  value: '1,024',
  detail: 'Units'
}, {
  label: 'Live units',
  value: '1,019',
  detail: 'Units'
}];
const emptySummaryMetrics: SummaryMetric[] = [{
  label: 'Received products',
  value: '0',
  detail: 'Products'
}, {
  label: 'Available for sale products',
  value: '0',
  detail: 'Products'
}, {
  label: 'Live products',
  value: '0',
  detail: 'Products'
}, {
  label: 'Received units',
  value: '0',
  detail: 'Units'
}, {
  label: 'Available for sale units',
  value: '0',
  detail: 'Units'
}, {
  label: 'Live units',
  value: '0',
  detail: 'Units'
}];
const onePeopleIncomingBatches = [{
  arrived: 'Feb 5, 2026',
  name: 'Spring overstock',
  expected: 1365,
  received: 1267,
  progress: 92.8
}, {
  arrived: 'Dec 6, 2025',
  name: 'Assembly part 4',
  expected: 7,
  received: 7,
  progress: 100
}, {
  arrived: 'Aug 30, 2025',
  name: 'August returns',
  expected: 337,
  received: 335,
  progress: 99.4
}, {
  arrived: 'Jul 10, 2025',
  name: 'July overstock',
  expected: 16,
  received: 16,
  progress: 100
}, {
  arrived: 'May 2, 2025',
  name: 'May overstock',
  expected: 258,
  received: 258,
  progress: 100
}];
const eddySummaryMetrics: SummaryMetric[] = [{
  label: 'Received products',
  value: '320',
  detail: 'Products'
}, {
  label: 'Available for sale products',
  value: '86',
  detail: 'Products'
}, {
  label: 'Live products',
  value: '82',
  detail: 'Products'
}, {
  label: 'Received units',
  value: '2,981',
  detail: 'Units'
}, {
  label: 'Available for sale units',
  value: '682',
  detail: 'Units'
}, {
  label: 'Live units',
  value: '669',
  detail: 'Units'
}];
const eddyIncomingBatches = [{
  arrived: 'Nov 4, 2026',
  name: 'Eddy — January 3PL transfer',
  expected: 85,
  received: 86,
  progress: 100
}, {
  arrived: 'Jan 28, 2026',
  name: 'Eddy Samples',
  expected: 0,
  received: 0,
  progress: 0
}, {
  arrived: 'Dec 16, 2025',
  name: 'Eddy — December 2025 3PL transfer',
  expected: 1103,
  received: 1105,
  progress: 100
}, {
  arrived: 'Nov 21, 2025',
  name: 'Eddy 3PL transfer',
  expected: 118,
  received: 120,
  progress: 100
}, {
  arrived: 'Oct 10, 2025',
  name: 'Eddy 3PL Transfer',
  expected: 87,
  received: 86,
  progress: 100
}, {
  arrived: 'May 22, 2025',
  name: 'Eddy — TJX Overflow',
  expected: 0,
  received: 223,
  progress: 97.4
}, {
  arrived: 'May 19, 2025',
  name: 'Eddy — 3PL Transfer',
  expected: 0,
  received: 845,
  progress: 99.7
}, {
  arrived: 'Sep 30, 2024',
  name: 'Eddy — October 3PL Transfer',
  expected: 22,
  received: 25,
  progress: 100
}, {
  arrived: 'Aug 13, 2024',
  name: 'Eddy — Fall 2024',
  expected: 168,
  received: 169,
  progress: 100
}, {
  arrived: 'Apr 8, 2024',
  name: 'Eddy April 2024',
  expected: 0,
  received: 0,
  progress: 100
}, {
  arrived: 'Jan 18, 2024',
  name: 'Eddy — Jan 2024',
  expected: 5,
  received: 0,
  progress: 100
}, {
  arrived: 'Dec 20, 1905',
  name: 'Eddy — 3PL transfer old',
  expected: 0,
  received: 183,
  progress: 100
}, {
  arrived: '—',
  name: 'Eddy — June TRX',
  expected: 139,
  received: 139,
  progress: 98.1
}, {
  arrived: '—',
  name: 'Eddy — 3PL Transfer',
  expected: 0,
  received: 0,
  progress: 0
}];
export function InventoryDashboard({
  selectedOwner
}: {
  selectedOwner: string;
}) {
  const hasOnePeopleData = selectedOwner === '1 People';
  const hasEddyData = selectedOwner === 'Eddy';
  const hasInventoryData = hasOnePeopleData || hasEddyData;
  const summaryMetrics = hasOnePeopleData ? onePeopleSummaryMetrics : hasEddyData ? eddySummaryMetrics : emptySummaryMetrics;
  const incomingBatches = hasOnePeopleData ? onePeopleIncomingBatches : hasEddyData ? eddyIncomingBatches : [];
  const totalMsrp = hasOnePeopleData ? '$130,993' : hasEddyData ? '$321,656' : '$0';
  const maxOpportunity = hasOnePeopleData ? '$65,437' : hasEddyData ? '$160,828' : '$0';
  const totalReceivedValue = hasOnePeopleData ? '$130,993' : hasEddyData ? '$320,582' : '$0';
  const overstockDetail = hasOnePeopleData ? '1,902 units across 189 products' : hasEddyData ? '2,981 units across 320 products' : '0 units across 0 products';
  return <div className="mx-auto max-w-7xl px-5 py-10 sm:px-8 lg:py-14" aria-labelledby="inventory-heading" data-id="element-910" data-mp="1pmnwzvghpuh1">
      <section className="flex flex-col gap-5 border-b border-ink/10 pb-8 sm:flex-row sm:items-end sm:justify-between" data-id="element-911" data-mp="23moz1e8hr7y3">
        <div data-id="element-912" data-mp="1yo5dvg1q206s">
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#BB5E40]" data-id="element-913" data-mp="1ynlurw0c55r6">
            <ArchiveIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-914" data-mp="9a8npz0u93md" />
            Inventory
          </span>
          <h1 id="inventory-heading" className="mt-3 font-display text-4xl font-medium tracking-tight sm:text-5xl" data-id="element-915" data-mp="4bfjyybcsqze">
            Inventory dashboard
          </h1>
          <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink/65 sm:text-lg" data-id="element-916" data-mp="2ku6hnwol2yiz">
            A clear view of inventory received, prepared for sale, and currently live across your approved recovery channels.
          </p>
        </div>
        <span className="inline-flex w-fit items-center gap-2 rounded-full bg-forest/8 px-3 py-1.5 text-xs font-semibold text-forest" data-id="element-917" data-mp="1x5wx0y33wgtf">
          <span className="h-1.5 w-1.5 rounded-full bg-forest" data-id="element-918" data-mp="2261fuurhlnmt" />
          {selectedOwner || 'All brands'}
        </span>
      </section>

      <section className="mt-8 grid gap-5 lg:grid-cols-[1.25fr_0.75fr]" aria-label="Inventory overview" data-id="element-919" data-mp="1o71ubvz9touv">
        <article className="rounded-3xl border border-ink/10 bg-paper p-5 shadow-sm sm:p-7" aria-labelledby="summary-heading" data-id="element-920" data-mp="1s8ws4qhztk3w">
          <div className="flex items-center gap-2" data-id="element-921" data-mp="3mkl7uuw1tqpc">
            <BoxesIcon className="h-4 w-4 text-[#BB5E40]" aria-hidden="true" data-id="element-922" data-mp="3mkbkzg6avznv" />
            <h2 id="summary-heading" className="text-lg font-semibold" data-id="element-923" data-mp="zdgwnmiws5jh">Inventory summary</h2>
          </div>
          <div className="mt-6 grid gap-x-5 gap-y-6 sm:grid-cols-3" data-id="element-924" data-mp="ucjevb1t9dii">
            {summaryMetrics.map((metric, index) => <div key={metric.label} className={`border-[#BB5E40]/25 pl-4 ${index % 3 === 0 ? 'border-l-0 pl-0' : 'border-l-2'} ${index >= 3 ? 'border-t pt-5 sm:border-t-0 sm:pt-0' : ''}`} data-id="element-925" data-mp="qdtqyoj5cdkm" data-mpi={index}>
                <p className="text-sm text-ink/55" data-id="element-926" data-mp="1i23upl2o3unk">{metric.label}</p>
                <p className="mt-1 font-display text-3xl font-semibold tracking-tight text-ink" data-id="element-927" data-mp="1e2czn563ysd8">{metric.value}</p>
                <p className="mt-1 text-xs text-ink/50" data-id="element-928" data-mp="1990n3tepec0u">{metric.detail}</p>
              </div>)}
          </div>
        </article>

        <article className="rounded-3xl border border-ink/10 bg-forest p-5 text-cream shadow-sm sm:p-7" aria-labelledby="opportunity-heading" data-id="element-929" data-mp="21qw5zf5lkv2o">
          <div className="flex items-center gap-2 text-cream/80" data-id="element-930" data-mp="1wz4nlrwlhvnm">
            <CircleDollarSignIcon className="h-4 w-4" aria-hidden="true" data-id="element-931" data-mp="24bkgbcal8g4v" />
            <h2 id="opportunity-heading" className="text-lg font-semibold text-cream" data-id="element-932" data-mp="24dnewkpt3hl7">Recovery value</h2>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-5" data-id="element-933" data-mp="2e9qgnpgqxe7m">
            <div data-id="element-934" data-mp="2e86ytuffyv3q">
              <p className="text-xs font-semibold uppercase tracking-wider text-cream/60" data-id="element-935" data-mp="2ebutwy0jbpkk">Total MSRP</p>
              <p className="mt-2 font-display text-3xl font-semibold tracking-tight" data-id="element-936" data-mp="2i8qxx3jks8si">{totalMsrp}</p>
            </div>
            <div data-id="element-937" data-mp="2s8zy0sgoued6">
              <p className="text-xs font-semibold uppercase tracking-wider text-cream/60" data-id="element-938" data-mp="2s8hpoxgr49ow">Max opportunity</p>
              <p className="mt-2 font-display text-3xl font-semibold tracking-tight" data-id="element-939" data-mp="2x116026tpixe">{maxOpportunity}</p>
            </div>
          </div>
          <p className="mt-5 border-t border-cream/15 pt-4 text-sm leading-relaxed text-cream/70" data-id="element-940" data-mp="3215m3r3tkbn3">Based on inventory that has been received and evaluated for recovery.</p>
        </article>
      </section>

      <section className="mt-5 grid gap-5 lg:grid-cols-[0.78fr_1.22fr]" data-id="element-941" data-mp="3axoft5jvk3kq">
        <article className="rounded-2xl border border-ink/10 bg-paper p-5 sm:p-6" aria-labelledby="overstock-heading" data-id="element-942" data-mp="3qoego7pz8j">
          <div className="flex items-center gap-2" data-id="element-943" data-mp="3rdpfv33df6ad">
            <PackageCheckIcon className="h-4 w-4 text-[#BB5E40]" aria-hidden="true" data-id="element-944" data-mp="a3rdkj8rj9kn" />
            <h2 id="overstock-heading" className="text-base font-semibold" data-id="element-945" data-mp="53v96iw5lg4k">Overstock</h2>
          </div>
          <p className="mt-5 text-sm text-ink/55" data-id="element-946" data-mp="3djol0kfji3fa">Total received value</p>
          <p className="mt-1 font-display text-4xl font-semibold tracking-tight text-ink" data-id="element-947" data-mp="38l52ku05n9ro">{totalReceivedValue}</p>
          <p className="mt-1 text-sm text-ink/55" data-id="element-948" data-mp="3n9riawtp23jf">{overstockDetail}</p>
          <div className="mt-6 rounded-xl bg-[#BB5E40]/5 p-4" data-id="element-949" data-mp="3nbufc0t9kwxn">
            <div className="flex items-start gap-2" data-id="element-950" data-mp="3iij7bwcpua45">
              <TrendingUpIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#BB5E40]" aria-hidden="true" data-id="element-951" data-mp="2utgqgqpwolap" />
              <p className="text-sm leading-relaxed text-ink/65" data-id="element-952" data-mp="2puvn4ifcxli1">Inventory moves into recovery once it is received, checked in, and matched to your current channel and pricing rules.</p>
            </div>
          </div>
        </article>

        <article className="overflow-hidden rounded-2xl border border-ink/10 bg-paper" aria-labelledby="incoming-heading" data-id="element-953" data-mp="1a4381mr6mc5j">
          <div className="flex items-center gap-2 border-b border-ink/10 px-5 py-5 sm:px-6" data-id="element-954" data-mp="vg8de0tm5xpt">
            <ClipboardListIcon className="h-4 w-4 text-[#BB5E40]" aria-hidden="true" data-id="element-955" data-mp="10drrn0qbaahr" />
            <h2 id="incoming-heading" className="text-base font-semibold" data-id="element-956" data-mp="1o4dw6i13xcn0">Inventory submissions</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-957" data-mp="1t1e4z0pcctht">
            <table className="w-full min-w-[690px] text-left text-sm" data-id="element-958" data-mp="1f2xoii1ofomh">
              <thead className="bg-cream/65 text-xs text-ink/50" data-id="element-959" data-mp="1f4qv5xcai8uh">
                <tr data-id="element-960" data-mp="1j2etzbh3slrn">
                  <th scope="col" className="px-5 py-3 font-semibold sm:px-6" data-id="element-961" data-mp="1j62nwbqgna6w">Arrived</th>
                  <th scope="col" className="px-3 py-3 font-semibold" data-id="element-962" data-mp="3lxy5ryw3jv3">Batch</th>
                  <th scope="col" className="px-3 py-3 text-right font-semibold" data-id="element-963" data-mp="7pm5c9jm0dft">Expected units</th>
                  <th scope="col" className="px-3 py-3 text-right font-semibold" data-id="element-964" data-mp="15ynp3vzgqfev">Net received</th>
                  <th scope="col" className="px-5 py-3 font-semibold sm:px-6" data-id="element-965" data-mp="1av4c2muxenqd">Receipt progress</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-ink/10" data-id="element-966" data-mp="x37u3bmz1u7p">
                {incomingBatches.length > 0 ? incomingBatches.map(batch => <tr key={batch.name} data-id="element-967" data-mp="n6laeq6dt979">
                    <td className="whitespace-nowrap px-5 py-4 text-ink/60 sm:px-6" data-id="element-968" data-mp="n8xsr4g1xlku">{batch.arrived}</td>
                    <th scope="row" className="px-3 py-4 font-medium text-ink" data-id="element-969" data-mp="s3v086xonmvm">{batch.name}</th>
                    <td className="px-3 py-4 text-right tabular-nums text-ink/70" data-id="element-970" data-mp="e89eq9qnrl7y">{batch.expected.toLocaleString('en-US')}</td>
                    <td className="px-3 py-4 text-right font-semibold tabular-nums text-ink" data-id="element-971" data-mp="28kh3148h53ur">{batch.received.toLocaleString('en-US')}</td>
                    <td className="px-5 py-4 sm:px-6" data-id="element-972" data-mp="2ckrgt32icyk6">
                      <div className="flex min-w-36 items-center gap-2" data-id="element-973" data-mp="yfoamkvj9b9">
                        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-ink/8" data-id="element-974" data-mp="wcxw1ft7e60">
                          <div className="h-full rounded-full bg-[#BB5E40]" style={{
                        width: `${batch.progress}%`
                      }} data-id="element-975" data-mp="3t430hql1jk1t" />
                        </div>
                        <span className="w-10 text-right text-xs tabular-nums text-ink/55" data-id="element-976" data-mp="5x0lse8qrew0">{batch.progress}%</span>
                      </div>
                    </td>
                  </tr>) : <tr data-id="element-977" data-mp="fo515f2bx1rd">
                    <td colSpan={5} className="px-5 py-10 text-center text-sm text-ink/55 sm:px-6" data-id="element-978" data-mp="fmtyxjoj822d">Select an owner to view inventory submissions.</td>
                  </tr>}
              </tbody>
            </table>
          </div>
        </article>
      </section>
    </div>;
}